import React from "react";
import "./LoadingScreen.css";

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="dot dot1" />
      <div className="dot dot2" />
      <div className="dot dot3" />
    </div>
  );
};

export default LoadingScreen;
